'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _alignments = require('../../../constants/alignments');

var _colors = require('../../../constants/colors');

var _sizes = require('../../../constants/sizes');

var _grid = require('../../../layouts/grid');

var _grid2 = _interopRequireDefault(_grid);

var _row = require('../../../layouts/row');

var _row2 = _interopRequireDefault(_row);

var _column = require('../../../layouts/column');

var _column2 = _interopRequireDefault(_column);

var _container = require('../../../layouts/container');

var _container2 = _interopRequireDefault(_container);

var _header = require('../../../atoms/text/header');

var _header2 = _interopRequireDefault(_header);

var _label = require('../../../atoms/text/label');

var _label2 = _interopRequireDefault(_label);

var _thumbsUp = require('./thumbsUp');

var _thumbsUp2 = _interopRequireDefault(_thumbsUp);

var _contactInfo = require('./contactInfo');

var _contactInfo2 = _interopRequireDefault(_contactInfo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Headline = function (_React$Component) {
    _inherits(Headline, _React$Component);

    function Headline(props) {
        _classCallCheck(this, Headline);

        var _this = _possibleConstructorReturn(this, (Headline.__proto__ || Object.getPrototypeOf(Headline)).call(this, props));

        _this.state = {
            chatHover: false,
            smsHover: false
        };
        return _this;
    }

    _createClass(Headline, [{
        key: 'render',
        value: function render() {

            var isMobile = this.context.screen.isMobile;

            return _react2.default.createElement(
                _react2.default.Fragment,
                null,
                _react2.default.createElement(
                    _grid2.default,
                    null,
                    _react2.default.createElement(
                        _row2.default,
                        { nogutter: true },
                        _react2.default.createElement(_column2.default, { xs: 0, md: 1 }),
                        _react2.default.createElement(
                            _column2.default,
                            { xs: 3 },
                            _react2.default.createElement(_thumbsUp2.default, { isMobile: this.context.screen.isMobile,
                                isTablet: this.context.screen.isTablet
                            })
                        ),
                        _react2.default.createElement(_column2.default, { xs: 1 }),
                        _react2.default.createElement(
                            _column2.default,
                            { xs: 8, md: 7 },
                            _react2.default.createElement(
                                _container2.default,
                                { fullSize: true, verticalAlignment: _alignments.Alignments.top, bottom: _sizes.Sizes.none },
                                _react2.default.createElement(_header2.default, { textAlign: _alignments.Alignments.left,
                                    color: _colors.Colors.Primary,
                                    size: this.context.screen.isMobile ? _sizes.Sizes.lg : _sizes.Sizes.xl,
                                    left: this.context.screen.isMobile && _sizes.Sizes.xs,
                                    top: _sizes.Sizes.xs,
                                    bottom: _sizes.Sizes.none,
                                    text: 'Perfect!'
                                }),
                                _react2.default.createElement(_header2.default, { textAlign: _alignments.Alignments.left,
                                    color: _colors.Colors.SecondaryText,
                                    size: this.context.screen.isMobile ? _sizes.Sizes.lg : _sizes.Sizes.xl,
                                    left: this.context.screen.isMobile && _sizes.Sizes.xs,
                                    top: _sizes.Sizes.none,
                                    bottom: _sizes.Sizes.xs,
                                    text: isMobile ? 'How would you like to take it from here?' : _react2.default.createElement(
                                        'div',
                                        null,
                                        'How would you like',
                                        _react2.default.createElement('br', null),
                                        'to take it from here?'
                                    )
                                }),
                                _react2.default.createElement(_label2.default, { textAlign: _alignments.Alignments.left,
                                    size: this.context.screen.isMobile ? _sizes.Sizes.lg : _sizes.Sizes.xl,
                                    left: this.context.screen.isMobile && _sizes.Sizes.xs,
                                    top: _sizes.Sizes.xs,
                                    bottom: _sizes.Sizes.xl,
                                    text: isMobile ? 'We need to confirm a few details to customize your discounts and coverage.' : _react2.default.createElement(
                                        'div',
                                        null,
                                        'We need to confirm a few details to customize',
                                        _react2.default.createElement('br', null),
                                        'your discounts and coverage.'
                                    )
                                }),
                                _react2.default.createElement(_contactInfo2.default, null)
                            )
                        )
                    )
                )
            );
        }
    }]);

    return Headline;
}(_react2.default.Component);

Headline.contextTypes = {
    screen: _propTypes2.default.object
};

exports.default = Headline;